import { useEffect, useRef } from 'react';
import { object, string } from 'prop-types';

import config from '~/config';

import styles from './Sovendus.module.scss';

const getHtml = ({ sessionId, country, timestamp }) => {
  const trafficSourceNumber =
    config.SOVENDUS_SHOP_ID[country] || config.SOVENDUS_SHOP_ID_DEFAULT;
  return `
<html lang="en">
<head>
  <meta charset="UTF-8">
  <title>Sovendus</title>
  <style>
  body {
    margin: 0;
    border: 0;
  }
  </style>
</head>
<script>
window.sovIframes = [
  {
    trafficSourceNumber: '${trafficSourceNumber}',
    trafficMediumNumber: '${config.SOVENDUS_MEDIUM}',
    sessionId: '${sessionId}',
    timestamp: '${timestamp}',
    orderId: '',
    orderValue: '',
    orderCurrency: '',
    usedCouponCode: '',
    iframeContainerId: 'sovendus-container',
  },
];
window.sovConsumer = {
    consumerSalutation      : '',
    consumerFirstName       : '',
    consumerLastName        : '',
    consumerEmail           : '',
    consumerStreet          : '',
    consumerStreetNumber    : '',
    consumerCountry         : '',
    consumerZipcode         : '',
    consumerCity            : '',
    consumerPhone           : '',
    consumerMobile          : '',
    consumerDateOfBirth     : '',
    consumerYearOfBirth     : ''
};
</script>
<body>
<div id="sovendus-container"></div>
<script src="${config.SOVENDUS_JS}" async="true"></script>
</body>
</html>
  `;
};

const Sovendus = ({ country, reward }) => {
  const observerRef = useRef();
  const iframeRef = useRef();

  if (!observerRef.current && window.ResizeObserver) {
    observerRef.current = new ResizeObserver((resizeList) => {
      if (iframeRef.current) {
        iframeRef.current.height = `${resizeList[0].contentRect.height}px`;
      }
    });
  }

  const onLoad = () => {
    const iframe = iframeRef.current;
    if (iframe) {
      iframe.height =
        iframe.contentDocument.body.getBoundingClientRect().height;
      observerRef?.current?.observe(iframe.contentDocument.body);
    }
  };

  useEffect(() => () => observerRef?.current?.disconnect(), []);

  return (
    <div className={styles.container}>
      <div className={styles.loader} />
      <iframe
        src="about:blank"
        ref={iframeRef}
        className={styles.sovendus}
        srcDoc={getHtml({
          country,
          sessionId: reward._id,
          timestamp: parseInt(reward._id.substring(0, 8), 16),
        })}
        onLoad={onLoad}
      />
    </div>
  );
};

Sovendus.propTypes = {
  country: string,
  reward: object.isRequired,
};

export default Sovendus;
